import LegalPage from "@/components/LegalPage";

export default function IntellectualProperty() {
  return (
    <LegalPage
      title="Intellectual Property & Copyright"
      seoDescription="How StUpEco Workspace's proprietary software, brand, content and designs are protected — and what remains outside our claim."
      path="/legal/intellectual-property"
      updated="August 2026"
      intro="StUpEco Workspace is built by Stupeco Private Limited. This page explains, in plain terms, what proprietary intellectual property we claim, what we do not, and how the platform and its content may be used."
      sections={[
        {
          heading: "1. What we own",
          body: [
            "StUpEco Workspace — including its original software code, product designs, user interface, brand name and logo, marketing content, documentation, workflows, frameworks, product methodology and other proprietary materials created by us — is owned by or licensed to Stupeco Private Limited, as applicable.",
            "Where third parties (including our contractors and content contributors) have contributed materials to Workspace under a licence or assignment, those materials are used with permission and remain covered by this notice.",
          ],
        },
        {
          heading: "2. Your permitted use",
          body: [
            "As a user or visitor, you may access and use StUpEco Workspace and the public website in the normal course of running your business, in accordance with our Terms & Conditions and Privacy Policy.",
            "You may share short excerpts, screenshots and links from the public website for review, commentary, journalism, education or personal reference, with clear attribution to StUpEco Workspace.",
          ],
        },
        {
          heading: "3. What is not permitted",
          body: [
            "Unauthorised copying, reproduction, distribution, commercial replication, framing, rebranding or systematic scraping of our protected proprietary materials — including our software code, product designs, brand identity, original content and documentation — may violate applicable intellectual-property, copyright and trade-mark rights.",
            "You may not represent yourself as StUpEco, our founders or the Stupeco Private Limited entity, nor imply endorsement, partnership or affiliation without our written permission.",
          ],
        },
        {
          heading: "4. What we do NOT claim",
          body: [
            "We do not claim ownership of generic ideas or general business concepts such as customer management, task management, projects, calendars, briefings or dashboards. These are common patterns in the SaaS industry.",
            "We do not claim ownership of standard SaaS features implemented in ways that are common across the industry.",
            "We do not claim ownership of third-party technologies, open-source components, libraries or fonts used within Workspace — those remain the property of their respective owners and are used under their respective licences.",
            "We do not claim rights to intellectual property that legally belongs to others — including any content, brands, trademarks or materials that our users, customers or third parties contribute or reference within their own workspace.",
          ],
        },
        {
          heading: "5. Your content stays yours",
          body: [
            "Business context, notes, tasks, deals, projects, meeting notes and other data that you enter into your Workspace remain your intellectual property. We only process such content to provide the service to you and only as described in our Privacy Policy.",
            "The Showcase consent you provide during signup (or later withdraw from Settings) is what governs whether we may publicly mention your business or profile in promotional or community materials — never anything more.",
          ],
        },
        {
          heading: "6. Reporting infringement",
          body: [
            "If you believe your intellectual property has been misused on StUpEco Workspace, or that our protected materials are being misused elsewhere, please contact us at contact@stupeco.com. Include enough detail for us to identify the material, the alleged infringement, and evidence of your rights.",
          ],
        },
        {
          heading: "7. Contact",
          body: [
            "For questions about this notice, licensing enquiries or attribution requests, write to contact@stupeco.com. This page may be updated from time to time as our products and materials evolve.",
          ],
        },
      ]}
    />
  );
}
